import ConvertDate from "../common/ConvertDate";

const fetchTourList = (state, action) => {
  return {
    tourlists: action.fetchedData,
    allTourLists: action.fetchedData,
    filterdStateTourList: action.fetchedData,
    filterdTypeTourList: action.fetchedData,
    sortedTypeTourList: action.fetchedData,
  };
};

const stateTourList = (state, action) => {
  const value = action.selectedOption.value;
  if (value === 2) {
    return {
      ...state,
      tourlists: state.allTourLists,
      filterdStateTourList: state.allTourLists,
    };
  } else {
    const updatedProducts = state.allTourLists.filter((p) => p.State === value);
    return {
      ...state,
      tourlists: updatedProducts,
      filterdStateTourList: updatedProducts,
    };
  }
};

const filterTourList = (state, action) => {
  const value = action.selectedOption.value;
  const allTours = [...state.filterdStateTourList];
  if (value === 3) {
    return {
      ...state,
      tourlists: state.filterdStateTourList,
      filterdTypeTourList: state.filterdStateTourList,
    };
  } else {
    const updatedProducts = allTours.filter((p) => p.PackageType === value);
    return {
      ...state,
      tourlists: updatedProducts,
      filterdTypeTourList: updatedProducts,
    };
  }
};

const sortTourList = (state, action) => {
  const value = action.selectedOption.value;
  const allTours = [...state.filterdTypeTourList];
  if (value === "lowest") {
    const sortedTours = allTours.sort((a, b) => {
      let aParam = a.PackageDate.slice(6, 19);
      let convetedDateAObject = ConvertDate(aParam);
      let convetedDateA = convetedDateAObject.props.children;
      let aParamSplitted = convetedDateA.replaceAll("/", "");

      let bParam = b.PackageDate.slice(6, 19);
      let convetedDateBObject = ConvertDate(bParam);
      let convetedDateB = convetedDateBObject.props.children;
      let bParamSplitted = convetedDateB.replaceAll("/", "");
      if (aParamSplitted > bParamSplitted) {
        return 1;
      }
      if (aParamSplitted < bParamSplitted) {
        return -1;
      }
      return 0;
    });
    return {
      ...state,
      tourlists: sortedTours,
      sortedTypeTourList: sortedTours,
    };
  } else {
    const sortedTours = allTours.sort((a, b) => {
      let aParam = a.PackageDate.slice(6, 19);
      let convetedDateAObject = ConvertDate(aParam);
      let convetedDateA = convetedDateAObject.props.children;
      let aParamSplitted = convetedDateA.replaceAll("/", "");

      let bParam = b.PackageDate.slice(6, 19);
      let convetedDateBObject = ConvertDate(bParam);
      let convetedDateB = convetedDateBObject.props.children;
      let bParamSplitted = convetedDateB.replaceAll("/", "");

      if (aParamSplitted < bParamSplitted) {
        return 1;
      }
      if (aParamSplitted > bParamSplitted) {
        return -1;
      }
      return 0;
    });
    return {
      ...state,
      tourlists: sortedTours,
      sortedTypeTourList: sortedTours,
    };
  }
};

const searchTourList = (state, action) => {
  const value = action.event;

  const allTours = [...state.sortedTypeTourList];
  if (value === "") {
    return {
      ...state,
      tourlists: state.allTourLists,
      filterdStateTourList: state.allTourLists,
    };
  } else {
    const filterdProducts = allTours.filter(
      (p) =>
        p.Title.toLowerCase().includes(value.toLowerCase()) ||
        p.PackageNumber.toLowerCase().includes(value.toLowerCase())
    );
    return {
      ...state,
      tourlists: filterdProducts,
    };
  }
};

const tourlistReducer = (state, action) => {
  switch (action.type) {
    case "STATE_TOUR":
      return stateTourList(state, action);
    case "FILTER_TOUR":
      return filterTourList(state, action);
    case "SORT_TOUR":
      return sortTourList(state, action);
    case "SEARCH_TOUR":
      return searchTourList(state, action);
    case "INITIALIZE_CART":
      return fetchTourList(state, action);
    default:
      return state;
  }
};

export default tourlistReducer;
